export default __webpack_public_path__ + "static/media/Dr-J-W-Bakal.5d1438f3.jpg";